import React, { useEffect, useState } from "react";
import Navigation from "../../components/navigation";
import QrSettings from "./qrSettings";
import { getAllTemplates, getPreMadeTemplates } from "../../redux/requests";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import useTypeDecription from "../../hooks/useTypeDecription";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import useWindowSize from "../../hooks/useWindowSize";
import {
  setDesignType,
  setDownloadQrType,
} from "../../redux/slices/customizeQr";
import {
  OverlayQrModal,
  ModalQrCode,
  ModalSuccessfullyDownload,
  ModalChooseQrType,
  ModalFrames,
  ModalLogo,
  MobilePreview,
  ModalArtQrSwitch,
  ModalClassicQrSwitch,
} from "../../components";
import useFrames from "../../hooks/useFrames";
import {
  qrCornetsInterior,
  qrCornetsOuter,
  qrPattern,
} from "../../redux/slices/qrSettings";
import { designTypes } from "../../constants/common";

export const DefaultLogoContext = React.createContext("");

export default function ThirdScreen() {
  const {
    link,
    linkStepValue,
    isOverlayModal,
    isQrCodeModal,
    isDownloadSuccessModal,
    showAgainDownloadSuccessModal,
    isFramesModal,
    isLogoModal,
    preloaderToggle,
    isBackgroundImageModal,
    isArtQrModal,
    isClassicQrModal,
  } = useSelector(
    (state) => ({
      link: state.getQrLinkSlice.link,
      linkStepValue: state.navigation.linkStepValue,
      isOverlayModal: state.qrOverlay.isOverlayModal,
      isQrCodeModal: state.modals.isQrCodeModal,
      isDownloadSuccessModal: state.modals.isDownloadSuccessModal,
      showAgainDownloadSuccessModal: state.modals.showAgainDownloadSuccessModal,
      isFramesModal: state.modals.isFramesModal,
      isLogoModal: state.modals.isLogoModal,
      preloaderToggle: state.preloader.toggle,
      isBackgroundImageModal: state.modals.isBackgroundImageModal,
      isArtQrModal: state.modals.isArtQrModal,
      isClassicQrModal: state.modals.isClassicQrModal,
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  const { showFooter, hideFooter } = useTypeDecription();

  const [defaultLogoData, setDefaultLogoData] = useState();
  const [defaultBackgroundImageData, setDefaultBackgroundImageData] =
    useState();

  const { isDownloadParam, entryLocation, isTemplateParam } =
    useCurrentLocation();
  const { isDesktop } = useWindowSize();
  const { frameConfigs } = useFrames();

  useEffect(() => {
    new Promise(async (res) => {
      await showFooter();
      await dispatch(getPreMadeTemplates(frameConfigs));
      await dispatch(getAllTemplates({ frameConfigs }));
      res();
    }).then(() => {
      if (sessionStorage.getItem("artQr")) {
        dispatch(setDesignType(designTypes.art));
        dispatch(qrPattern("small-dots"));
        dispatch(qrCornetsOuter("square"));
        dispatch(qrCornetsInterior("square"));
        sessionStorage.removeItem("artQr");
      }
      if (isDownloadParam) {
        document
          .querySelector(isDesktop ? "#bottomDownloadBtn" : "#downloadQrCode")
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
        dispatch(setDownloadQrType("svg"));
      }
    });
    return () => hideFooter();
  }, []);

  const showModalChooseQrType = !(link || linkStepValue) && !entryLocation;

  return (
    <DefaultLogoContext.Provider
      value={{
        defaultLogoData,
        setDefaultLogoData,
        defaultBackgroundImageData,
        setDefaultBackgroundImageData,
      }}
    >
      <Navigation />
      {isOverlayModal && <OverlayQrModal />}
      {isQrCodeModal && <ModalQrCode />}
      {isDownloadSuccessModal &&
        showAgainDownloadSuccessModal &&
        !preloaderToggle && <ModalSuccessfullyDownload />}
      {showModalChooseQrType && <ModalChooseQrType />}
      {isFramesModal && <ModalFrames />}
      {(isLogoModal || isBackgroundImageModal) && <ModalLogo />}
      {!isTemplateParam && !isDesktop && (link || linkStepValue) && (
        <MobilePreview />
      )}
      {isArtQrModal && <ModalArtQrSwitch />}
      {isClassicQrModal && <ModalClassicQrSwitch />}
      <QrSettings />
    </DefaultLogoContext.Provider>
  );
}
